import React, { lazy } from 'react'
import { LazyRoute } from 'Modules'
import { FrontUrls } from 'Src/constants/FrontUrls'
import { Switch } from 'react-router-dom'

const ActsGrid = lazy(() => import('Pages/acts/components/desktop_acts/ActsList/index'))
export const ActsDesktopRoutes = () => (
	<Switch>
		<LazyRoute exact path={FrontUrls.new_acts} lazyComponent={ActsGrid} key={FrontUrls.new_acts} />
	</Switch>
)
